const API_KEY = 'AIzaSyCqoX_PXw618ZFDNkWTIKrhEVQm_WdTH9M'
const SENDER_ID = '990876023021'
const PROJECT_ID = 'alfamed2-8431b'
const APP_ID = '806cd77d266a1f9d67f4e4'

export const VAPID_KEY = 'BL9K4SW4kmdmYD4XyNFexlkoWYU8ihwSUPhN7bG2iZIEKLcszT1rn54YwuWxJo6OAPpcYAn_TInZ35Bp-m3pG2E'

export const FIREBASE_CONFIG = {
    apiKey: API_KEY,
    authDomain: `${PROJECT_ID}.firebaseapp.com`,
    projectId: PROJECT_ID,
    storageBucket: `${PROJECT_ID}.appspot.com`,
    messagingSenderId: `${SENDER_ID}`,
    appId: `1:${SENDER_ID}:web:${APP_ID}`,
    measurementId: "G-GMT5MDV141",
}
